// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"709":"f92836cc","731":"a70d7570","905":"03956953"}[chunkId] + ".chunk.js";
};